import React, { FC } from "react";

import { ButtonInputProps, ButtonInput } from "./ButtonInput/ButtonInput";
import { RadioInputProps, RadioInput } from "./RadioInput/RadioInput";
import { HiddenInputProps, HiddenInput } from "./HiddenInput/HiddenInput";
import {
  CheckboxInputProps,
  CheckboxInput,
} from "./CheckboxInput/CheckboxInput";
import {
  GenericTextualInput,
  GenericTextualInputProps,
} from "./TextualInput/GenericTextualInput/GenericTextualInput";
import {
  PhoneInput,
  PhoneInputProps,
} from "./TextualInput/PhoneInput/PhoneInput";
import {
  SearchInput,
  SearchInputProps,
} from "./TextualInput/SearchInput/SearchInput";

export type InputProps =
  | ButtonInputProps
  | CheckboxInputProps
  | HiddenInputProps
  | GenericTextualInputProps
  | PhoneInputProps
  | RadioInputProps
  | SearchInputProps;
export const Input: FC<InputProps> = (props) => {
  switch (props.type) {
    case "tel": {
      return <PhoneInput {...props} />;
    }
    case "radio": {
      return <RadioInput {...props} />;
    }
    case "button":
    case "file":
    case "reset":
    case "submit": {
      return <ButtonInput {...props} />;
    }
    case "checkbox": {
      return <CheckboxInput {...props} />;
    }
    case "hidden": {
      return <HiddenInput {...props} />;
    }
    case "search": {
      return <SearchInput {...props} />;
    }
    default: {
      return <GenericTextualInput {...props} />;
    }
  }
};
